import { render } from "./KeyWordsForm.vue?vue&type=template&id=17c50294&ts=true"
import script from "./KeyWordsForm.vue?vue&type=script&lang=ts"
export * from "./KeyWordsForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__